import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Chevron Right"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-chevron-right',
    templateUrl: './icon-chevron-right.component.html',
    styleUrls: ['./icon-chevron-right.component.scss'],
    standalone: false
})
export class IconChevronRightComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
